import * as madnes from "../../framework/src/engine/madnes/madnes";
import * as MV from "../../framework/src/engine/madnes/madnes_variables";
import {reset_faded_in_anim, rotate_run} from "../ps_core";
import {ps_print_desk} from "../ps_reels";
import {update_desk} from "../ps_config";
import {
    openinfo,
    ps_infomenu_home,
    ps_infomenu_close,
    ps_infomenu_init,
    ps_infomenu_left,
    ps_infomenu_open,
    ps_infomenu_right, ps_infomenu_update
} from "../ps_infomenu";
import {start_standing_symbols} from "../ps_anims";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {behavior_config, server_config} from "../../framework/src/engine/madnes/madnes_variables";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "en", "fr", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "sk", "pt", "es-mx", "bg", "it", "lt"
];

export function initGame(gameset) {

    reset_faded_in_anim();

    MV.set_config_load_symbols(false);

    madnes.set_ico_size(258, 258 - 50);

    // madnes_show_money_anim_callback_timeout = 40;

    madnes.set_sprite('_sprite', 258, 258);
    madnes.set_sprite('_blur', 258, 258);
    madnes.set_sprite('_sheet', 258, 258);
    madnes.set_sprite('_touchdown', 258, 258);
    madnes.set_sprite('_standing', 258, 258);
    madnes.set_sprite('_to_symbol_', 258, 258);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            // end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            ps_infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function initLoad() {

}

export function game_start() {
    main_phaser.time.desiredFps = 120;
    rotate_run()
}

export function print_desk() {
    server_config.behavior = behavior_config
    ps_print_desk()
}

export function print_reels() {
    update_desk();
}

export function infomenu_init() {
    ps_infomenu_init();
}

export function infomenu_open() {
    ps_infomenu_open();
}

export function infomenu_close() {
    ps_infomenu_close();
}

export function infomenu_home() {
    ps_infomenu_home();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    ps_infomenu_left();
}

export function infomenu_right() {
    ps_infomenu_right();
}

export function end_round_no_autostart() {
}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}
